import React, { Component } from "react";
import { translate } from "react-i18next";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import { Col, Form, FormGroup, Row } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";

import graphActions from "../actions/graphActions";
import { isLoggedIn } from "../services/AuthenticationService";
import Validations from "../components/Validations";
import {
  Dropdown,
  UserDropdown,
  Loading,
  Valert,
  DateTimePicker,
  Vmodal,
  RichDropdown,
} from "../components";
import i18n from "../i18n";
import GraphChart from "../components/GraphChart";
import "./styles/graph.css";
import "./styles/graphModern.css";
class OptionForm extends Component {
  constructor(props) {
    super(props);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.plot = this.plot.bind(this);
    this.DEFAULT_EXPORT_OPT = { data: false, graph: false, tfi: false, custom: false };
    this.state = {
      start: moment(),
      end: moment(),
      dlModal: false,
      exportOpt: {
        data: false,
        graph: false,
        tfi: false,
        custom: false,
      },
    };
    this.props.change("start", moment().format("Y-M-D"));
    this.props.change("end",   ""); // or "null"
  }

  changeStartDate(e, t) {
    e.set({ h: 0, m: 0, s: 0 });
    this.setState({ start: e });
    this.props.change("start", e.format("Y-M-D"));
  }

  changeEndDate(e, t) {
    e.set({ h: 0, m: 0, s: 0 });
    this.setState({ end: e });
    this.props.change("end", e.format("Y-M-D"));
  }

  plot() {
    this.props.submit();
  }

  exportClicked() {
    this.setState({ dlModal: false });
    this.props.onTfiExport(this.props.optForm, this.state.exportOpt);
    this.setState({ exportOpt: { ...this.DEFAULT_EXPORT_OPT } });
  }

  // ADD: one place to reset selection + close modal
  resetExportModal = () => {
    this.setState({
      dlModal: false,
      exportOpt: { ...this.DEFAULT_EXPORT_OPT },
    });
  };

  render() {
    const {
      disabled,
      onChangeForm,
      factors,
      nutrients,
      searchMode,
      toggleInfoModal,
    } = this.props;

    // Format numbers: <1000 show as-is; >=1000 -> exact K if multiple of 1000, else floor K+
    const formatCount = (n) => {
      const x = Number(n || 0);
      if (x < 1000) return String(x);
      const k = Math.floor(x / 1000);
      return (x % 1000 === 0) ? `${k}K` : `${k}K+`;
    };

    // Build text-only labels for widest compatibility of Trigger dropdown with ✓ and ✗ using tg, tcg, ti
    let nutrientOptions = Array.isArray(nutrients)
      ? nutrients.map(n => {
          // ✅ Skip badge rendering if flagged noBadges
          if (n.noBadges) {
            const labelTextRaw =
              (typeof n.label === "string" && n.label) || n.name || n.value || "";
            const sortKey = String(labelTextRaw).toLowerCase();
            return {
              ...n,
              sortKey,
              label: (
                <span className="nut-opt">
                  <span className="nut-name">{labelTextRaw}</span>
                </span>
              ),
            };
          }

          const checks = Number(n.tg || 0) + Number(n.tcg || 0);
          const crosses = Number(n.ti || 0);

          // Build a robust plain-text key for sorting
          const labelTextRaw =
            (typeof n.label === "string" && n.label) ||
            n.name ||
            n.value ||
            "";
          const sortKey = String(labelTextRaw).toLowerCase();

          // Keep value/unit/etc., only override label with JSX
          return {
            ...n,
            checks,
            crosses,
            sortKey, // used only for sorting
            label: (
              <span className="nut-opt">
                <span className="nut-name">{n.label}</span>
                <span className="nut-badges">
                  {checks === 0 && crosses === 0 ? (
                    <span className="nut-insufficient">
                      {this.props.t("graph.LACK_DATA")}
                    </span>
                  ) : (
                    <span>
                    {/* green number */}
                    <span className="nut-num nut-check-num">{formatCount(checks)}</span>
                    
                    {/* pipe in normal text color */}
                    <span className="nut-sep"> | </span>
                    
                    {/* red number */}
                    <span className="nut-num nut-x-num">{formatCount(crosses)}</span>
                    </span>
                  )}
                </span>
              </span>
            ),
          };
        })
      : nutrients;

    // detect Food & Supplement - Nutrient by id instead of name
    const isFoodSupNutrient = String((this.props.optForm && this.props.optForm.factor) || "") === "02061";

    // apply sorting only if NOT Food & Supplement - Nutrient
    if (Array.isArray(nutrientOptions) && !isFoodSupNutrient) {
      nutrientOptions = nutrientOptions
        .slice() // avoid in-place sort if you prefer immutability
        .sort((a, b) =>
          // (b.crosses || 0) - (a.crosses || 0) ||  // Criteria 1: Sort descending order or cross
          // (b.checks || 0) - (a.checks || 0) ||    // Criteria 2: Sort descending order or checks
          a.sortKey.localeCompare(b.sortKey, undefined, { sensitivity: "base" })  // Criteria 2: Sort alphabetically
        );
    }

    // strip sortKey before render
    if (Array.isArray(nutrientOptions)) {
      nutrientOptions = nutrientOptions.map(({ sortKey, ...rest }) => rest);
    }

    const submitHandler = (values) => {
      // handle form submission logic here
      console.log("Form Submitted with values:", values);
    };
    return (
      <Form onSubmit={this.props.handleSubmit(submitHandler)}>
        <Vmodal
          displayStatus={this.state.dlModal}
          zIndex="99"
          data={
            // marginLeft: 15, marginRight: 15, paddingTop: 20
            <div style={{ width: 350, paddingTop: 25 }}>

              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {this.props.t("graph.ANALYZE_EXPORT_DATA_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 18px 0", lineHeight: 1.4 }}>
                {this.props.t("graph.ANALYZE_EXPORT_DATA_TEXT")}
              </p>

              <FormGroup row>
                <Col xs="12">
                  <div
                    onClick={() =>
                      this.setState({
                        exportOpt: {
                          ...this.state.exportOpt,
                          data: !this.state.exportOpt.data,
                        },
                      })
                    }
                    className="checkmarkContainer"
                    style={{ marginBottom: 0, fontSize: "1rem" }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.exportOpt.data}
                    />
                    <label style={{ padding: "3px 0", marginBottom: 0 }}>
                      {this.props.t("graph.EXPORT_GRAPH_TEXT")}
                    </label>
                    <span className="checkmark" />
                  </div>
                  <div
                    // onClick={() =>
                    //   this.setState({
                    //     exportOpt: {
                    //       ...this.state.exportOpt,
                    //       graph: !this.state.exportOpt.graph,
                    //     },
                    //   })
                    // }
                    onClick={() => {}}
                    className="checkmarkContainer"
                    // className="checkmarkContainer disabledExport"
                    style={{ 
                      marginBottom: 0, 
                      fontSize: "1rem",
                      pointerEvents: "none",    // disable clicking
                      opacity: 0.45,            // grey all elements
                      cursor: "not-allowed",     // UX signal
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.exportOpt.graph}
                      disabled={true}
                    />
                    <label style={{ padding: "3px 0", marginBottom: 0 }}>
                      {this.props.t("graph.EXPORT_GRAPH_DATA_TEXT")}
                    </label>
                    <span className="checkmark" />
                  </div>
                  <div
                    onClick={() =>
                      this.setState({
                        exportOpt: {
                          ...this.state.exportOpt,
                          tfi: !this.state.exportOpt.tfi,
                        },
                      })
                    }
                    className="checkmarkContainer"
                    style={{ marginBottom: 0, fontSize: "1rem" }}
                  >
                    <input type="checkbox" checked={this.state.exportOpt.tfi} />
                    <label style={{ padding: "3px 0", marginBottom: 0 }}>
                      {this.props.t("graph.EXPORT_TRIGGER_TEXT")}
                    </label>
                    <span className="checkmark" />
                  </div>
                  <div
                    onClick={() =>
                      this.setState({
                        exportOpt: {
                          ...this.state.exportOpt,
                          custom: !this.state.exportOpt.custom,
                        },
                      })
                    }
                    className="checkmarkContainer"
                    style={{ marginBottom: 0, fontSize: "1rem" }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.exportOpt.custom}
                    />
                    <label style={{ padding: "3px 0", marginBottom: 0 }}>
                      {this.props.t("graph.EXPORT_CUSTOM_TEXT")}
                    </label>
                    <span className="checkmark" />
                  </div>
                </Col>
              </FormGroup>
              <div style={{ textAlign: "right" }}>
                <i
                  class="fa fa-info-circle"
                  style={{
                    color: "#2296FF",
                    fontSize: "30px",
                    marginLeft: "5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    toggleInfoModal();
                  }}
                ></i>
              </div>

              <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.exportClicked()}
                  disabled={
                    this.state.exportOpt.data ||
                      this.state.exportOpt.graph ||
                      this.state.exportOpt.tfi ||
                      this.state.exportOpt.custom
                      ? false
                      : true
                  }
                >
                  {this.props.t("general.EXPORT_DATA_BUTTON")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.resetExportModal}
                >
                  {this.props.t("general.CANCEL")}
                </button>
              </div>

            </div>
          }
          closeFunc={this.resetExportModal}
        />
        <FormGroup>
          <Field
            name="user"
            className="chooseUser"
            component={RichDropdown}
            onChange={(e) => {
              onChangeForm(e);
              this.props.change("symptom", "null");  // clear symptom selection
              this.props.change("factor", "null"); // clear category selection
              this.props.change("nutrients", "null"); // clear trigger selection
            }}
            options={this.props.users}
            t={this.props.t}
          />
        </FormGroup>

        <FormGroup>
          <Field
            name="symptom"
            className="chooseUser"
            component={RichDropdown}
            disabled={!this.props.optForm.user} // Disable if no user selected
            options={
              this.props.symptoms && this.props.symptoms.length > 0
                ? this.props.symptoms
                : [
                  {
                    label: this.props.t("graph.NO_SYMPTOM_DROPDOWN_TEXT"),
                    value: "empty",
                  },
                ]
            }
            placeholder={this.props.t("general.CATEGORY_SYMPTOM")}
            onChange={(e) => {
              onChangeForm(e);
              this.props.change("factor", "null"); // clear category selection
              this.props.change("nutrients", "null"); // clear trigger selection
            }}
            val={this.props.optForm.symptom}
          />
        </FormGroup>

        <FormGroup>
          <Row>
            <Col>
              <Field
                name="factor"
                disabled={disabled.factor}
                className="chooseUser"
                component={RichDropdown}
                options={factors}
                placeholder={this.props.t("graph.CATEGORY_FIELD_TEXT")}
                onChange={(e) => {
                  var selectedItem = factors.find((element) => {
                    return element.value == e.target.value;
                  });
                  this.props.change("nutrients", "null"); // clear trigger selection
                  selectedItem
                    ? this.props.onChangefactor(
                        e.target.value,
                        selectedItem.label,
                        this.props.optForm.user,
                        this.props.optForm.symptom
                      )
                    : onChangeForm(e);
                }}
                val={this.props.optForm.factor}
              />
            </Col>

            <Col>
              <Field
                name="nutrients"
                disabled={disabled.nutrients}
                className="dropdownList"
                component={RichDropdown}
                options={
                  nutrientOptions && nutrientOptions.length > 0
                    ? nutrientOptions
                    : [{ label: this.props.t("graph.NO_TRIGGER_DROPDOWN_TEXT"), value: "empty" }]
                }
                placeholder={this.props.t("general.NUTRIENTS_FIELD_TEXT")}
                placeholderAdornment={
                  <span className="nut-badges">
                    <i className="fa fa-check nut-check-ico" aria-hidden="true" />
                    <span className="nut-sep">|</span>
                    <i className="fa fa-times nut-x-ico" aria-hidden="true" />
                  </span>
                }
                onChange={(e) => {
                  onChangeForm(e);
                }}
                val={this.props.optForm.nutrients}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup className="analyzeTimeRow">
          <Row>
            <Col xs="6">
              <DateTimePicker
                placeholder={this.props.t("general.FROM_DATE_TEXT")}
                value={this.props.optForm.start || ""}
                onChange={this.props.onDateChange}
                dateFormat="DD MMM YYYY"
                timeDisable="true"
                disableFutureDates={true}
                disabled={disabled.start}
                dark={true}
                dailyAndAnalyze={true}
              />
            </Col>
            <Col xs="4">
              <Field
                name="end"
                className="chooseUser"
                component={RichDropdown}
                options={[
                  { value: "1W", label: i18n.t("graph.1WEEK_OPTION_TEXT") },
                  { value: "2W", label: i18n.t("graph.2WEEKS_OPTION_TEXT") },
                  { value: "1M", label: i18n.t("graph.1MONTH_OPTION_TEXT") },
                  { value: "3M", label: i18n.t("graph.3MONTH_OPTION_TEXT") },
                  { value: "6M", label: i18n.t("graph.6MONTH_OPTION_TEXT") },
                  { value: "1Y", label: i18n.t("graph.1YEAR_TEXT_OPTION") },
                  { value: "2Y", label: i18n.t("graph.2YEARS_TEXT_OPTION") },
                  { value: "5Y", label: i18n.t("graph.5YEARS_TEXT_OPTION") },
                ]}
                placeholder={this.props.t("general.NUMBER_OF_DAYS_TEXT")}
                disabled={disabled.end}
                onChange={(e) => onChangeForm(e)}
                val={this.props.optForm.end || ""}
              />
            </Col>
            <Col xs="2">
              <button
                type="button"
                className="btn btn-primary  btnWide editInputSearchBtn"
                onClick={() => {
                  searchMode
                    ? this.props.plot(this.props.optForm)
                    : this.setState({ dlModal: true });
                }}
                disabled={disabled.plotBtn}
              >
                <i
                  style={{ fontSize: "20px" }}
                  className={
                    searchMode ? "fa fa-chart-line" : "fas fa-file-export"
                  }
                />
              </button>
            </Col>
          </Row>
        </FormGroup>
      </Form>
    );
  }
}

OptionForm = reduxForm({
  form: "formGraphOption",
  enableReinitialize: true,
})(OptionForm);

OptionForm = connect((state) => ({
  initialValues: state.graphManagement.OptionForm,
}))(OptionForm);

class Graph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoModal: false,
    };
    this.yRightList = { data: [0, 20, 40, 60, 80], min: 0, max: 100 };
  }

  componentWillUnmount() {
    this.props.resetPage();
  }

  componentDidMount() {
    if (!isLoggedIn()) {
      this.props.history.push("/");
      return;
    }
    var baseUser = localStorage.getItem("user");
    let user = JSON.parse(baseUser);
    this.props.graphInitialization(user._id);
  }

  toggleInfoModal() {
    this.setState({
      infoModal: true,
    });
  }

  render() {
    const {
      isLoading,
      t,
      disabled,
      onChangeForm,
      counterState,
      factors,
      selectedUser,
      nutrients,
      onDateChange,
      OptionForm: optForm,
      plot,
      graphSymptoms,
      graphFactors,
      chartPeriod,
      yLabels,
      searchMode,
    } = this.props;
    return (
      <div className="black-container analyzePage analyze-modern">
        <Loading isLoading={isLoading} />
        <Vmodal
          displayStatus={this.state.infoModal}
          zIndex="100"
          data={
            <div>
              <h4>{t("graph.INFO_ICON_MSG_TITLE")}</h4>
              <ul
                style={{
                  listStyleType: "disc",
                  textAlign: "justify",
                  fontSize: "14px",
                  padding: "0px 15px 10px 15px",
                }}
              >
                <li>{t("graph.INFO_ICON_MSG_1")}</li>
                <li>{t("graph.INFO_ICON_MSG_2")}</li>
                <li>{t("graph.INFO_ICON_MSG_3")}</li>
                <li>{t("graph.INFO_ICON_MSG_4")}</li>
              </ul>
              <p
                style={{
                  color: "black",
                  marginLeft: "4px",
                  textAlign: "justify",
                  padding: "0 15px 10px 0",
                }}
              >
                {t("graph.INFO_ICON_MSG_5")}
              </p>
            </div>
          }
          closeFunc={() => {
            this.setState({
              infoModal: false,
            });
          }}
        />
        <Valert
          display={this.props.exportSuccess}
          title={t("general.CHECK_EMAIL_TITLE")}
          question={t("general.ANALYZE_PAGE_CHECK_EMAIL_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />

        <Valert
          display={this.props.pointAlert}
          title={t("graph.POINT_ALERT_TITLE")}
          question={t("graph.POINT_ALERT_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <div className="stock">
          <div className="formContainer">
            <OptionForm
              plot={plot}
              optForm={optForm}
              symptoms={this.props.symptoms}
              users={this.props.users}
              factors={factors}
              onSubmit={this.updateGraph}
              t={t}
              disabled={disabled}
              onChangeForm={onChangeForm}
              counterState={counterState}
              searchMode={searchMode}
              onChangefactor={this.props.onChangefactor}
              selectedUser={selectedUser}
              nutrients={nutrients}
              onDateChange={onDateChange}
              onTfiExport={this.props.onTfiExport.bind(this)}
              toggleInfoModal={this.toggleInfoModal.bind(this)}
            />
          </div>
          <div
            className="graphPageChartContainer"
            style={{ position: "relative" }}
          >
            {graphSymptoms.length === 0 && graphFactors.length === 0 ? (
              <p
                style={{
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "700",
                }}
              >
                {this.props.factorsStatus === 404
                  ? this.props.t("general.NO_DATA_FOUND_TEXT")
                  : this.props.t("general.SEARCH_REQUIRED_TEXT")}
              </p>
            ) : null}
            {graphSymptoms.length > 0 || graphFactors.length > 0 ? (
              <GraphChart
                firstData={graphSymptoms}
                secondData={graphFactors}
                xLabelsData={chartPeriod}
                yLabelsData={yLabels}
                yRightLabels={this.yRightList}
                optionForm={optForm}
                t={this.props.t}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

Graph = translate("translations")(Graph);

const mapStateToProps = (state) => ({
  ...state.graphManagement,
  formGraphOption: state.form.formGraphOption,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...graphActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Graph);



// WEBPACK FOOTER //
// ./src/pages/Graph.js